import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { SxProps, Theme } from '@mui/material/styles'
import {
  surveyEntryStatCardSx,
  surveyEntryStatIconWrapRewardSx,
  surveyEntryStatIconWrapSx,
  surveyEntryStatLabelSx,
  surveyEntryStatValueDurationSx,
  surveyEntryStatValueMutedSx,
  surveyEntryStatValueSx,
} from '../styles/surveyEntryStyles'

interface SurveyEntryStatCardProps {
  readonly label: string
  readonly value: string
  readonly icon: ReactNode
  readonly variant?: 'default' | 'duration' | 'muted'
  readonly rewardIcon?: boolean
  readonly testId?: string
}

export function SurveyEntryStatCard({
  label,
  value,
  icon,
  variant = 'default',
  rewardIcon = false,
  testId,
}: SurveyEntryStatCardProps) {
  let valueSx: SxProps<Theme> = surveyEntryStatValueSx
  if (variant === 'muted') {
    valueSx = surveyEntryStatValueMutedSx
  } else if (variant === 'duration') {
    valueSx = surveyEntryStatValueDurationSx
  }

  return (
    <Box sx={surveyEntryStatCardSx} data-testid={testId}>
      <Box sx={rewardIcon ? surveyEntryStatIconWrapRewardSx : surveyEntryStatIconWrapSx}>
        {icon}
      </Box>
      <Box>
        <Typography component="p" sx={surveyEntryStatLabelSx}>
          {label}
        </Typography>
        <Typography component="p" sx={valueSx}>
          {value}
        </Typography>
      </Box>
    </Box>
  )
}
